// Angular
import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from '../../../core/_base/layout';
// Auth
import { AuthNoticeService } from '../../../core/auth';
import { Router } from '@angular/router'

import { Stringable, StringableValues } from '../../../common/stringable.decorator'

import { StateService } from '../../../services/state.service';

const KEY_AUTH = 'auth-component'

@Stringable({
	path: 'views/pages/auth/auth',
	key: KEY_AUTH,
})


@Component({
	selector: 'kt-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
	encapsulation: ViewEncapsulation.None
})




export class AuthComponent implements OnInit {
	
	@StringableValues(KEY_AUTH) strings: any
	// Public properties
	today: number = Date.now();
	headerLogo: string;
    message_app: string;
	/**
	 * Component constructor
	 *
	 * @param el
	 * @param render
	 * @param layoutConfigService: LayoutConfigService
	 * @param authNoticeService: authNoticeService
	 * @param translationService: TranslationService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private el: ElementRef,
		private render: Renderer2,
		private layoutConfigService: LayoutConfigService,
		public authNoticeService: AuthNoticeService,
		private translationService: TranslationService,
		private splashScreenService: SplashScreenService,
		private router: Router,
		private stateService: StateService,
		private cdr: ChangeDetectorRef,
		) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.headerLogo = this.layoutConfigService.getLogo();

		this.splashScreenService.hide();
        console.log("AuthComponent",this.strings)
		// load default styles
		this.loadCSS('./assets/css/demo1/style.bundle.css');
		this.loadCSS('/style/atyl_layerGESTAMAT.css');
		/*
		this.stateService.messages.subscribe(messages => {
			if (messages.APP_MENTION!=undefined 
			&& messages.APP_MENTION.message!=undefined) {
				this.message_app=messages.APP_MENTION.message;
				this.cdr.detectChanges();
			}
		});
		*/
	}

	/**
	 * Load CSS for this specific page only, and destroy when navigate away
	 * @param styleUrl
	 */
	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement('link');
			styleElement.href = styleUrl;
			styleElement.type = 'text/css';
			styleElement.rel = 'stylesheet';
			styleElement.onload = resolve;
			this.render.appendChild(this.el.nativeElement, styleElement);
		});
	}
}
